<template>
  <div class="collection">
    <!------搜索模块---->
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="2" ref="BLM-search">
        <el-form-item prop="payState" label="付款状态">
          <el-select
            v-model="searchData.payState"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in completionStatusList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="times" label="应付日期">
          <el-date-picker
            v-model="searchData.times"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="completeDate" label="完成时间">
          <el-date-picker
            v-model="searchData.completeDate"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="payeeType" label="收款方类型">
          <el-select
            v-model="searchData.payeeType"
            placeholder="请选择收款方类型"
            clearable
            @change="changePayeeType"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in payeeTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="customerInfoType"
          label="客户类型"
        >
          <el-select
            v-model="searchData.customerInfoType"
            clearable
            :disabled="searchData.payeeType === 1"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="个人" :value="1"></el-option>
            <el-option label="企业" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="payeeId" clearable label="收款方">
          <QS-select
            v-model="searchData.payeeId"
            filterable
            placeholder="请输入关键词"
            clearable
            :disabled="isPayeeType"
            :remote="searchData.payeeType === 2"
            :remote-method="getPayCustomerList"
            :loading="oLoading.fuzzySearch"
            @change="(value) => payeeIdChange(value, 'payeeId', customerList, 'id', 'customerName')"
          >
            <QS-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.customerName"
              :value="item.id"
            >
              <CustomerNameOptionItem :data="item" />
            </QS-option>
          </QS-select>
        </el-form-item>

        <el-form-item prop="carId" clearable label="车牌号">
          <el-select
            v-model="searchData.carId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入"
            clearable
            :remote-method="
              (query) => {
                gerCarNoList(query)
              }
            "
            :loading="loading"
            @change="(value) => carIdChange(value, 'carId', carList, 'id', 'plateNo')"
          >
            <el-option
              v-for="item in carList"
              :key="item.id"
              :label="item.plateNo"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="sourceOrderType" label="来源单类型">
          <el-select
            v-model="searchData.sourceOrderType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in sourceOrderTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="sourceOrderId" clearable label="来源单ID">
          <el-input
            v-model="searchData.sourceOrderId"
            v-number:integer="20"
            placeholder="请输入来源单ID"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item prop="payType" label="付款内容">
          <el-select
            v-model="searchData.payType"
            clearable
            placeholder="请选择"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in freeTypeList"
              :label="item.name"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="changeState" label="是否变更">
          <el-select
            v-model="searchData.changeState"
            clearable
            placeholder="请选择是否变更"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in isWhetherList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="purchaseType" label="采购方式">
          <el-select
            v-model="searchData.purchaseType"
            clearable
            placeholder="请选择采购方式"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in purchaseTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="id" clearable label="应付ID">
          <el-input
            v-number:integer
            v-model="searchData.id"
            placeholder="请输入应付ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="deptIdList" label="所属部门">
          <DeptSelect ref="deptSelectRef" v-model="searchData.deptIdList" multiple :isAll="false" />
        </el-form-item>
          <el-form-item prop="providerId" label="车源方">
            <el-select
              v-model="searchData.providerId"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in carProviderList"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
          </el-select>
        </el-form-item>
        <CarBrandSeriesModel
          ref="carBrandSeriesModelRef"
          v-model="searchData.brandSeriesModel"
          :showModel="true"
          :filterScene="CAR_MODEL_FILTER_SCENE.IN_STOCK">
        </CarBrandSeriesModel>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              size="small"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset"
              >重置</el-button
            >
          </el-form-item>
          <el-form-item v-if="judgePermission('finance_payment_excel')">
            <PublicExport
              exportTitle="应付导出"
              exportTemplate="Payment"
              :getSearchData="getSearchParams"
              templateCode="vehicle-payment-info"
              :getSearchCondition="getSearchCondition"
            />
          </el-form-item>
        </template>
      </QS-search>
    </el-form>

    <QS-common-table
      :data="tableData"
      :columns="headColumn"
      :pagination="paginationData"
      @change="paginationChange"
    >
      <template slot="operation-group">
        <el-button
          v-if="judgePermission('finance_payment_add')"
          size="small"
          type="primary"
          @click="addFn"
          >新增应付</el-button
        >
        <el-button
          @click="addRecordHandle"
          v-if="judgePermission('finance_batch_payment_add_payable')"
        >批量付款</el-button>
      </template>
      <template slot="tools">
        <p>
          当前条件下：应付金额：
          <span v-thousand-separator="currentSummary.paySum"></span>
          元 已付金额：
          <span v-thousand-separator="currentSummary.paidSum"></span>
          元 剩余应付金额：
          <span v-thousand-separator="currentSummary.remainSum"></span>
          元
        </p>
      </template>
    </QS-common-table>

    <!------新建应付---->
    <div v-if="oShow.addReceivable">
      <dialogWrap
        v-model="oShow.addReceivable"
        :title="addTitle"
        :width="'824px'"
        @change="addChangeHandle"
      >
        <AddReceivable
          ref="addReceivable"
          :type="2"
          :payeeTypeList="payeeTypeList"
        ></AddReceivable>
        <template slot="footer">
          <el-button size="small" @click="cencelFn('receivable')"
            >取消</el-button
          >
          <el-button
            :loading="oLoading.add"
            size="small"
            type="primary"
            v-submitDingTalkShow="21"
            @click="submitAddCollecetion"
            >确认新增</el-button
          >
        </template>
      </dialogWrap>
    </div>
    <!------新建付款单---->
    <dialogWrap v-model="oShow.addBill" :title="addTitleOrder" :width="'900px'">
      <AddReceipt
        ref="addBill"
        v-if="oShow.addBill"
        :data="detailSource"
        :optionType="2"
        :type="1"
      />
      <template slot="footer">
        <el-button size="small" @click="cencelFn('bill')">取消</el-button>
        <el-button
          :loading="oLoading.addOrder"
          size="small"
          type="primary"
          v-submitDingTalkShow="22"
          @click="addBillSubmit"
          >确认新增</el-button
        >
      </template>
    </dialogWrap>

    <dialogWrap
      v-model="oShow.complete"
      title="提示"
      width="'560px'"
      custom-class="dialog-message"
    >
      <div v-html="completeDialogTitle"></div>
      <template slot="footer">
        <el-button size="small" @click="cencelFn('complete')">取消</el-button>
        <el-button
          :loading="oLoading.state"
          size="small"
          type="primary"
          @click="submitCompleteHandle"
          >确认</el-button
        >
      </template>
    </dialogWrap>

    <!-- 新增变更计划 -->
    <PayableAddChangePlan
      v-model="oShow.changePlan"
      :row="addChangePlanData"
      @searchHandle="searchHandle"
    />

    <!-- 12.26 线下批量付款弹窗 -->
    <BatchCollectionRecordAdd
      :visible.sync="oShow.batchCollectionRecordAddVisible"
      scenetype="payment"
      @refresh="searchHandle"
    />
  </div>
</template>

<script>
import AddReceivable from '@/pages/finance/addReceivable.vue'
import AddReceipt from '@/pages/finance/addReceipt.vue'
import PayableAddChangePlan from '@/pages/finance/components/PayableAddChangePlan.vue'
import BatchCollectionRecordAdd from './collection/components/BatchCollectionRecordAdd/index.vue'
// eslint-disable-next-line import/no-cycle
import {
  getSensitivePaymentList,
  getCollectCustomerList,
  updatePayState,
  getPaymentDetails,
  addPaymentOrder,
  addPayment,
  getPaymentStatistic,
} from '@/api/financeApi'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { getCarProvider } from '@/api/carManage'
// eslint-disable-next-line import/no-named-as-default
import submitDingTalkShow from '@/directives/submitDingTalkShow'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import selectOption from '@/store/dict/selectOptionDict'
import { debounce } from '@/utils'
import { mapState } from 'vuex'
import { operateMaxShowLength } from '@/store/dict/config'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import { generateExportCondition } from '@/utils/exportUtils.js'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default {
  name: 'collection',
  components: {
    AddReceivable,
    AddReceipt,
    PayableAddChangePlan,
    CustomerNameOptionItem,
    BatchCollectionRecordAdd,
  },
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  data() {
    return {
      currentSummary: {}, // 统计
      oLoading: {
        fuzzySearch: false,
        search: false,
        add: false,
        addOrder: false,
        state: false,
      },
      sourceOrderTypeDict: selectOption.sourceOrderTypeDict,
      paymentStatusDict: selectOption.paymentStatusDict,
      loading: false,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      customerList: [], // 模糊搜索用户
      carList: [], // 模糊搜索车牌号
      // 添加新增付款单的组件
      addBillCompnents: null,
      searchData: {
        id: '',
        carIdTwin: '',
        payeeId: '',
        carId: '',
        sourceOrderId: '',
        sourceOrderType: '',
        payState: '',
        payeeType: '',
        payType: '',
        times: [], // 应付时间
        completeDate: [], // 完成时间
        deptIdList: [],
        providerId: '', // 车源方ID
        modelId: '', // 车型
        changeState: '', // 是否变更
        purchaseType: '', // 采购方式
        customerInfoType: '',
        brandSeriesModel: {},
      },
      completeId: '',
      completeDialogTitle: '',
      oShow: {
        addBill: false,
        addReceivable: false,
        complete: false,
        changePlan: false,
        batchCollectionRecordAddVisible: false,
      },
      addTitleOrder: '新增付款单',
      addTitle: '新增应付',
      headColumn: [
        {
          name: 'id',
          columnProps: {
            label: '应付ID',
            prop: 'id',
            width: 100,
          },
          render: ({ row }) => {
            return (
              <a class="cursor-pointer">
                {this.judgePermission('finance_payment_detail') && (
                  <span
                    class="td-canclick"
                    onClick={() => this.viewDetails(row.id)}
                  >
                    {row.id}
                  </span>
                )}
                {!this.judgePermission('finance_payment_detail') && (
                  <span class="td-canclick">{row.id}</span>
                )}
              </a>
            )
          },
        },
        {
          name: 'sourceOrderType',
          columnProps: {
            label: '来源单类型',
            prop: 'sourceOrderType',
            width: 110,
          },
          getText: ({ row }) => this.sourceOrderTypeDict[row.sourceOrderType],
        },
        {
          name: 'sourceOrderId',
          columnProps: {
            label: '来源单ID',
            prop: 'sourceOrderId',
          },
        },
        {
          name: 'payType',
          columnProps: {
            label: '付款内容',
            prop: 'payType',
          },
          getText: ({ row }) =>
            this.formatEnumeration(this.freeTypeList)[row.payType],
        },
        {
          name: 'payeeType',
          columnProps: {
            label: '收款方类型',
            prop: 'payeeType',
            width: 100,
          },
          getText: ({ row }) => selectOption.customerTypeDict[row.payeeType],
        },
        {
          name: 'customerInfoType',
          columnProps: {
            label: '客户类型',
            prop: 'customerInfoType',
          },
          render: ({ row }) => {
            if (!row.customerInfoType) return <span>--</span>
            return row.customerInfoType === 1 ? (
              <span>个人</span>
            ) : (
              <span>企业</span>
            )
          },
        },
        {
          name: 'payee',
          columnProps: {
            label: '收款方',
            prop: 'payee',
            width: 160,
          },
        },
        {
          name: 'payeeId',
          columnProps: {
            label: '收款方id',
            prop: 'payeeId',
          },
        },
        {
          name: 'carId',
          columnProps: {
            label: '车辆ID',
            prop: 'carId',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
            width: 100,
          },
        },
        {
          name: 'purchaseType',
          columnProps: {
            label: '采购方式',
            prop: 'purchaseType',
          },
        },
        {
          name: 'providerName',
          columnProps: {
            label: '车源方',
            prop: 'providerName',
            width: 160,
          },
        },
        {
          name: 'brandName',
          columnProps: {
            label: '品牌',
            prop: 'brandName',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            label: '车系',
            prop: 'seriesName',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            label: '车型',
            prop: 'modelName',
            width: 160,
          },
        },
        {
          name: 'payDate',
          columnProps: {
            label: '应付时间',
            prop: 'payDate',
            width: 100,
          },
        },
        {
          name: 'accruedCycle',
          columnProps: {
            label: '款项周期',
            prop: 'accruedCycle',
            width: 100,
          },
        },
        {
          name: 'payAmount',
          columnProps: {
            label: '应付(元)',
            prop: 'payAmount',
            width: 160,
          },
          getText: ({ row }) => this.numberWithCommas(row.payAmount),
        },
        // 财务审批 需求中新增 字段 doc: https://bailongma.yuque.com/hhwu0d/yizg52/niomzpf77bxv6oog#sRRue
        {
          name: 'payingAmount',
          columnProps: {
            label: '付款中金额(元)',
            prop: 'payingAmount',
            width: 160,
          },
          getText: ({ row }) => this.numberWithCommas(row.payingAmount),
        },
        {
          name: 'paidAmount',
          columnProps: {
            label: '已付',
            prop: 'paidAmount',
            width: 160,
          },
          getText: ({ row }) => this.numberWithCommas(row.paidAmount),
        },
        // 财务审批 需求中新增 字段 doc: https://bailongma.yuque.com/hhwu0d/yizg52/niomzpf77bxv6oog#sRRue
        {
          name: 'remainAmount',
          columnProps: {
            label: '剩余应付金额(元)',
            prop: 'remainAmount',
            width: 160,
          },
          getText: ({ row }) => this.numberWithCommas(row.remainAmount),
        },
        {
          name: 'payState',
          columnProps: {
            label: '付款状态',
            prop: 'payState',
            'render-header': () => {
              const title = this.$createElement('span', '付款状态')
              const content = this.$createElement(
                'div',
                {
                  slot: 'content',
                },
                [
                  this.$createElement(
                    'p',
                    '待订单核算：车辆入库后，因当期租金实收金额大于应收金额，生成应付单。需订单核算完成后，再进行付款操作。',
                  ),
                  this.$createElement('p', '未完成： 已付金额小于应付金额。'),
                  this.$createElement('p', '已完成：已付金额等于应付金额。'),
                  this.$createElement('p', '已关闭：应收单关闭。'),
                ],
              )
              const icon = this.$createElement('i', {
                class: {
                  'QS-icon-question-outline': true,
                },
              })
              const tooltip = this.$createElement(
                'el-tooltip',
                {
                  props: {
                    placement: 'top',
                  },
                },
                [content, icon],
              )

              return this.$createElement(
                'p',
                {
                  class: {
                    'components-page__ColumnHeader': true,
                  },
                },
                [title, tooltip],
              )
            },
            width: 120,
          },
          getText: ({ row }) => this.paymentStatusDict[row.payState],
        },
        {
          name: 'completeTime',
          columnProps: {
            label: '完成时间',
            prop: 'completeTime',
            width: 100,
          },
        },
        {
          name: 'changeState',
          columnProps: {
            label: '是否变更',
            prop: 'changeState',
          },
          getText: ({ row }) => selectOption.isWhetherList[row.changeState],
        },
        {
          name: 'deptName',
          columnProps: {
            label: '所属部门',
            prop: 'deptName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const btnList = []

            // “待订单核算”没有操作
            if (row.payState === 3) return btnList
            if (this.judgePermission('financePayList')) {
              btnList.push({
                name: 'look',
                label: '查看付款单',
                action: () => this.linkReceipt(row.id),
              })
            }
            // 维保商城
            if (row.sourceOrderType === 7) return btnList

            if (
              this.judgePermission('finance_payment_bill_add') &&
              Number(row.payState) !== 1 &&
              Number(row.paidAmount) <= Number(row.payAmount) &&
              Number(row.payState) !== 2 &&
              Number(row.sourceOrderType) !== 3
            ) {
              btnList.push({
                name: 'pay',
                label: '付款',
                action: () => this.addBillDialog(row.id),
              })
            }
            if (
              Number(row.payState) !== 1 &&
              Number(row.sourceOrderType) !== 3 &&
              Number(row.paidAmount) <= Number(row.payAmount) &&
              Number(row.payState) !== 2 &&
              this.judgePermission('finance_payment_changePayment')
            ) {
              btnList.push({
                name: 'change',
                label: '变更',
                action: () => this.addChangePlan(row),
              })
            }

            if (
              Number(row.payState) !== 1 &&
              Number(row.sourceOrderType) !== 3 &&
              this.judgePermission('finance_payment_state') &&
              Number(row.paidAmount) === 0 &&
              Number(row.payState) !== 2
            ) {
              btnList.push({
                name: 'close',
                label: '关闭',
                action: () => this.completeHandle(row.id),
              })
            }
            return btnList
          },
        },
      ],
      addReceivableRef: null,
      tableData: [],
      detailSource: {},
      addChangePlanData: {},
      isPayeeType: true, // 是否禁用收款方
      carProviderList: [], // 车源方列表
      payeeIdConditionList: [], // 收款方列表
      carIdConditionList: [], // 车牌号列表
      CAR_MODEL_FILTER_SCENE,
    }
  },
  watch: {
    'searchData.payeeId': {
      handler() {
        this.payeeIdConditionList = this.customerList
      },
    },
    'searchData.carId': {
      handler() {
        this.carIdConditionList = this.carList
      },
    },
  },
  mounted() {
    this.getQueryParams()
    this.initSearchData()
    this.getPaymentList()
    this.$refs['BLM-search'].searchMoreClick()
    this.getCarProvider()
  },
  methods: {
    // 获取车源方列表
    getCarProvider() {
      getCarProvider({
        state: 1,
        serviceType: 0,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.carProviderList = data.items
        }
      })
    },
    // 付款方选中类型
    changePayeeType(val) {
      this.customerList = []
      this.searchData.payeeId = ''
      this.searchData.customerInfoType = ''
      // 类型为其他-付款方禁用，不可填写
      if (val === 3 || !val) {
        this.customerList = []
        this.isPayeeType = true
      } else {
        this.isPayeeType = false
      }
      if (!val) return
      this.getCustomerHandle()
    },
    // 新增变更计划
    addChangePlan(row) {
      this.addChangePlanData = row
      this.oShow.changePlan = true
    },
    // 获取请求参数
    getSearchParams() {
      let startDate = ''
      let endDate = ''
      let completeStartDate = ''
      let completeEndDate = ''
      if (this.searchData.times && this.searchData.times.length > 0) {
        startDate = this.searchData.times[0]
        endDate = this.searchData.times[1]
      }
      if (
        this.searchData.completeDate &&
        this.searchData.completeDate.length > 0
      ) {
        completeStartDate = this.searchData.completeDate[0]
        completeEndDate = this.searchData.completeDate[1]
      }
      const { brandSeriesModel } = this.searchData
      const params = {
        ...this.searchData,
        brandId: brandSeriesModel.brandId,
        seriesId: brandSeriesModel.seriesId,
        modelId: brandSeriesModel.modelId,
      }
      delete params.brandSeriesModel
      return {
        ...params,
        startDate,
        endDate,
        completeStartDate,
        completeEndDate,
      }
    },

    // 获取应收列表 && 应付列表统计
    async getPaymentList() {
      this.saveSearchData()
      this.oLoading.search = true
      try {
        const { code, data } = await getSensitivePaymentList({
          ...this.getSearchParams(),
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        })
        this.oLoading.search = false
        if (code === 1) {
          this.paginationData.total = data?.totalNum || 0
          this.tableData = data?.items || []
        }
      } catch (error) {
        this.oLoading.search = false
      }
      getPaymentStatistic({
        ...this.getSearchParams(),
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.currentSummary = data
        }
      })
    },

    // 搜索事件
    searchHandle(toFirstPage = true) {
      // eslint-disable-next-line no-mixed-operators
      this.paginationChange({
        pagination: {
          pageSize: this.paginationData.pageSize,
          pageNum: (toFirstPage && 1) || this.paginationData.pageNum,
        },
      })
    },

    // 获取应付详情
    async getPaymentDetails(id) {
      try {
        const { code, data } = await getPaymentDetails({ id })
        return new Promise((resolve, reject) => {
          if (code === 1) {
            this.detailSource = {
              ...data,
              payAmount: `${this.numberWithCommas(data.payAmount)}元`,
              paidAmount: `${this.numberWithCommas(data.paidAmount)}元`,
            }
            Object.keys(this.detailSource).forEach((item) => {
              if (item === 'sourceOrderType') {
                this.detailSource[item] =
                  this.sourceOrderTypeDict[this.detailSource[item]]
              }
              if (item === 'payState') {
                this.detailSource[item] =
                  this.paymentStatusDict[this.detailSource[item]]
              }
              if (item === 'payType') {
                this.detailSource[item] = this.formatEnumeration(
                  this.freeTypeList,
                )[this.detailSource[item]]
              }
            })
            resolve()
          } else {
            reject()
          }
        })
      } catch (error) {
        return new Promise((resolve, reject) => {
          reject()
        })
      }
    },

    // 查看详情
    viewDetails(id) {
      this.$router.push({
        path: '/finance/payable/detail',
        query: { id },
      })
    },

    linkReceipt(id) {
      this.$router.push({
        path: '/finance/payList',
        query: { id },
      })
    },

    // 通过收款方类型去查收款方  1服务商接口2客户接口
    getCustomerHandle() {
      //  服务商
      if (Number(this.searchData.payeeType) === 1) {
        this.oLoading.fuzzySearch = true
        getCollectCustomerList().then(({ code, data }) => {
          if (code === 1) {
            this.customerList = data.items.map((item) => ({
              ...item,
              customerName: item.name,
              customerTel: item.contactTel,
            }))
          }
        }).finally(() => {
          this.oLoading.fuzzySearch = false
        })
      }
    },
    // 模糊搜索付款方 客户
    async getPayCustomerList(query) {
      // 开启远程搜索
      if (query.length < 1) return
      this.oLoading.fuzzySearch = true
      const params = {
        customerState: 1,
        customerName: query,
      }
      if (this.searchData.customerInfoType) {
        params.customerType = this.searchData.customerInfoType
      } else { // 全部的时候 不需要校验类型
        params.mixedType = 'YES'
      }
      searchByCustomerNameSensitive(params).then(({ code, data }) => {
        if (code === 1) {
          // 关闭远程搜索
          this.customerList = data
        }
      }).finally(() => {
        this.oLoading.fuzzySearch = false
      })
    },
    // 模糊搜索获取车牌号
    async gerCarNoList(query) {
      if (query.length >= 4) {
        // 开启远程搜索
        this.oLoading.fuzzySearch = true
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 1,
          })
          // 关闭远程搜索
          this.oLoading.fuzzySearch = false
          if (code === 1) {
            this.carList = data
          }
        } catch (error) {
          this.oLoading.fuzzySearch = false
        }
      }
    },

    // 新增付款单
    addBillDialog: debounce(function (id) {
      this.getPaymentDetails(id)
        .then(() => {
          this.oShow.addBill = true
        })
    }, 500),

    // 取消按钮操作
    cencelFn(type) {
      if (type === 'complete') {
        this.oShow.complete = false
      }
      if (type === 'bill') {
        if (this.addBillCompnents) {
          this.addBillCompnents.reset('financeAddBill')
        }
        this.oShow.addBill = false
      }
      if (type === 'receivable') {
        this.addReceivableRef.formResetFields()
        this.oShow.addReceivable = false
      }
    },

    // 添加事件关闭操作，清空验证
    addChangeHandle(bol) {
      if (!bol) {
        this.addReceivableRef.formResetFields()
      }
    },

    // 新建应付
    addFn() {
      this.oShow.addReceivable = true
      this.$nextTick(() => {
        this.addReceivableRef = this.$refs.addReceivable
      })
    },

    // 新建批量付款
    addRecordHandle() {
      // 变更为点击弹窗
      this.oShow.batchCollectionRecordAddVisible = true
    },

    // 新增收款单
    addBillSubmit() {
      const msg = this.DingTalkShow22 ? '提交审批成功' : '操作成功'
      this.$refs.addBill
        .formValidate()
        .then((data) => {
          this.oLoading.addOrder = true
          addPaymentOrder(data)
            .then(({ code }) => {
              this.oLoading.addOrder = false
              if (code === 1) {
                this.$message.success(msg)
                this.getPaymentList()
                this.oShow.addBill = false
              }
            })
            .catch(() => {
              this.oLoading.addOrder = false
            })
        })
        .catch(() => null)
    },

    // 提交新建应收
    submitAddCollecetion() {
      const msg = this.DingTalkShow21 ? '提交审批成功' : '操作成功'
      this.addReceivableRef
        .formValidate()
        .then((postData) => {
          this.oLoading.add = true
          addPayment(postData)
            .then(({ code }) => {
              this.oLoading.add = false
              if (code === 1) {
                this.$message.success(msg)
                this.addReceivableRef.formResetFields()
                this.oShow.addReceivable = false
                this.getPaymentList()
              }
            })
            .catch(() => {
              this.oLoading.add = false
            })
        })
        .catch(() => null)
    },

    // 确认完成弹窗
    completeHandle(id) {
      const data = this.tableData.filter((item) => {
        return item.id === id
      })[0]
      this.completeDialogTitle = `提前完成付款单，将无法继续付款。<br>
当前应付${data.payAmount}元，已付${data.paidAmount}元，是否放弃支付剩余金额${data.endMoney}元？`
      this.oShow.complete = true
      this.completeId = id
    },

    // 完成事件
    async submitCompleteHandle() {
      this.oLoading.state = true
      try {
        const { code } = await updatePayState({
          id: this.completeId,
          payState: 2,
        })
        this.oLoading.state = false
        if (code === 1) {
          this.$message.success('操作成功')
          this.oShow.complete = false
          this.getPaymentList()
        }
      } catch (error) {
        this.oLoading.state = false
      }
    },
    reset() {
      sessionStorage.removeItem('finance_payable_search_params')
      this.formResetFields('search')
    },
    formResetFields(form) {
      this.$refs[form].resetFields()
      this.paginationData.pageNum = 1
      this.$refs.carBrandSeriesModelRef.reset()
      this.searchData.brandSeriesModel = {}
      this.searchData = Object.assign({}, this.searchData)
      this.getPaymentList()
      this.customerList = []
      this.isPayeeType = true
      this.carList = []
    },
    // 分页事件
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getPaymentList()
    },
    getQueryParams() {
      const {
        times = '',
        payType = '',
        purchaseType = '',
        deptId = '',
      } = this.$route.query
      if (payType !== '') {
        this.searchData.payType = Number(payType)
      }
      if (purchaseType !== '') {
        this.searchData.purchaseType = Number(purchaseType)
      }
      if (deptId !== '') {
        this.searchData.deptIdList = [Number(deptId)]
      }
      if (times !== '') {
        this.searchData.times = JSON.parse(times)
      }
    },
    getSearchCondition() {
      const formConfig = [{
        el: 'select',
        itemConfig: {
          label: '付款状态',
          prop: 'payState',
        },
        elConfig: {
          options: {
            list: this.completionStatusList,
            value: 'value',
            label: 'label',
          },
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '应付日期',
          prop: 'times',
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '完成时间',
          prop: 'completeDate',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '收款方类型',
          prop: 'payeeType',
        },
        elConfig: {
          options: {
            list: this.payeeTypeList,
            value: 'value',
            label: 'label',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '客户类型',
          prop: 'customerInfoType',
        },
        elConfig: {
          options: {
            list: [{
              label: '个人',
              value: 1,
            }, {
              label: '企业',
              value: 2,
            }],
            label: 'label',
            value: 'value',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '收款方',
          prop: 'payeeId',
        },
        elConfig: {
          options: {
            list: this.payeeIdConditionList,
            label: 'customerName',
            value: 'id',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '车牌号',
          prop: 'carId',
        },
        elConfig: {
          options: {
            list: this.carIdConditionList,
            label: 'plateNo',
            value: 'id',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '来源单类型',
          prop: 'sourceOrderType',
        },
        elConfig: {
          options: {
            list: this.sourceOrderTypeList,
            label: 'label',
            value: 'value',
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '来源单ID',
          prop: 'sourceOrderId',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '付款内容',
          prop: 'payType',
        },
        elConfig: {
          options: {
            list: this.freeTypeList,
            label: 'name',
            value: 'code',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '是否变更',
          prop: 'changeState',
        },
        elConfig: {
          options: {
            list: this.isWhetherList,
            label: 'label',
            value: 'value',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '采购方式',
          prop: 'purchaseType',
        },
        elConfig: {
          options: {
            list: this.purchaseTypeList,
            label: 'label',
            value: 'value',
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '应付ID',
          prop: 'id',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '所属部门',
          prop: 'deptIdList',
        },
        elConfig: {
          options: {
            list: this.$refs.deptSelectRef.flatOptions(),
            value: 'id',
            label: 'name',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '车源方',
          prop: 'providerId',
        },
        elConfig: {
          options: {
            list: this.carProviderList,
            value: 'id',
            label: 'name',
          },
        },
      }]
      const list = formConfig.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = this.searchData[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      const { brandSeries, model } = this.$refs.carBrandSeriesModelRef.getLabels()
      list.push(brandSeries)
      list.push(model)
      return list
    },
    // 搜索条件保存到sessionStorage
    saveSearchData() {
      const params = {
        ...this.searchData,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }
      sessionStorage.setItem('finance_payable_search_params', JSON.stringify(params))
    },
    // 从sessionStorage初始化搜索条件
    initSearchData() {
      const searchData = sessionStorage.getItem('finance_payable_search_params')
      if (searchData) {
        try {
          this.searchData = JSON.parse(searchData)
          this.paginationData.pageSize = this.searchData.pageSize
          this.paginationData.pageNum = this.searchData.pageNum
          // 如果收款方类型是服务商且收款方有值
          if (this.searchData.payeeType === 1 && this.searchData.payeeId) {
            this.isPayeeType = false
            this.getCustomerHandle()
          } else if (this.searchData.payeeType === 2 && this.searchData.payeeId) {
            // 如果收款方类型是客户且收款方有值
            this.isPayeeType = false
            this.customerList = [{
              id: this.searchData.payeeId,
              customerName: this.searchData.customerName,
              customerTel: this.searchData.customerTel,
            }]
          }
          // 对于车牌号的远程搜索
          if (this.searchData.carId) {
            this.gerCarNoList(this.searchData.carIdLabel || '')
          }
          // 对于品牌车系的处理
          if (this.searchData.brandId) {
            this.brandSeriesModel = {
              brandId: this.searchData.brandId,
              seriesId: this.searchData.seriesId,
              modelId: this.searchData.modelId,
            }
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        this.paginationData.pageSize = 10
        this.paginationData.pageNum = 1
      }
    },
    carIdChange(val, prop, options, value, label) {
      if (!val) {
        this.carList = []
      }
      const item = options.find((obj) => obj[value] === Number(val))
      this.searchData.carIdLabel = item ? item[label] : ''
    },
    payeeIdChange(val, prop, options, value, label) {
      const filterItem = options.find((obj) => obj[value] === Number(val))
      this.searchData.customerName = filterItem ? filterItem.customerName : ''
      this.searchData.customerTel = filterItem ? filterItem.customerTel : ''
    },
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    completionStatusList() {
      return this.dictParseList(selectOption.paymentStatusDict, true)
    },
    sourceOrderTypeList() {
      return this.dictParseList(selectOption.sourceOrderTypeDict, true)
    },
    payeeTypeList() {
      const result = {}
      for (const key in selectOption.customerTypeDict) {
        if (Object.hasOwnProperty.call(selectOption.customerTypeDict, key)) {
          if (Number(key) !== 10) {
            result[key] = selectOption.customerTypeDict[key]
          }
        }
      }
      return this.dictParseList(result)
    },
    // 是否
    isWhetherList() {
      return this.dictParseList(selectOption.isWhetherList)
    },
    purchaseTypeList() {
      return this.dictParseList(selectOption.purchaseType)
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  activated() {
    this.initSearchData()
  },
}
</script>
<style scoped lang="scss">
.operation-box {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-content: center;
  padding-top: 16px;
}
.customer {
  display: flex;
  flex-direction: row;
  &-name {
    // float: left;
    width: 80px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }
  &-phone {
    // float: left;
    color: #8492a6;
    font-size: 13px;
    margin: 0;
    padding-left: 20px;
  }
}
</style>
